import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import GamingHubComponent from './GamingHubComponent';
import config from './../config';
import common from "../common";
import $ from 'jquery'

class MainHeader extends Component {
    constructor(props) {

        super(props);
        this.state = {
            adHeight: !config.isMobile ? '350px' : 'auto',
            index: 0,
            isAdDetectcodeloaded: false,
            isAdBlocked: true
        }
        this.resizeObserver = null;
        this.resizeElement = React.createRef();
    }


    param = [{
        'id': 'PS@1x.png-top-presented-by',
        'name': 'Sony PS',
        'creative': 'Logo 65x35',
        'position': 'top'
    }];

    setAdsFlag = (flag, isAdBlocked) => {
        let self = this;
        self.setState({
            isAdDetectcodeloaded: flag,
            isAdBlocked: isAdBlocked,
            adHeight: isAdBlocked ? 'auto' : !config.isMobile ? '350px' : 'auto'

        })
    }

    componentWillMount() {
        //check if ads are available
        common.detectAdBlocker(this.setAdsFlag)

    }
    componentDidMount() {
        let self = this
        try {
            // window.googletag.cmd.push(function () {
            //     window.googletag.display('div-gpt-ad-1410518459199-1');
            // });


            setTimeout(function () {
                if (window.googletag && window.googletag.apiReady) {
                    window.googletag.cmd.push(function () {
                        window.googletag.display('div-gpt-ad-1410518459199-1');
                    });
                    window.googletag.pubads().refresh([window.gptAdSlots[1]]);

                    window.googletag
                        .pubads()
                        .addEventListener('slotRenderEnded', function (event) {

                        });
                }



                self.resizeObserver = new window.ResizeObserver(
                    (entries) => {
                        self.setState({
                            index: self.state.index + 1
                        })

                        console.log('entries', entries[0].contentRect);
                        // do things
                        if (self.state.index > 1) {
                            if (entries[0].contentRect.height >= 131) {
                                self.setState({
                                    adHeight: "350px"
                                })
                                // entries[0].target.style.height =
                                //     self.state.adHeight;
                            } else if (entries[0].contentRect.height < 131) {
                                self.setState({
                                    adHeight: "auto"
                                })
                            }
                        }



                    }
                );

                self.resizeObserver.observe(
                    self.resizeElement.current
                );
            }, 1000)





        } catch (e) {
        }
        common.adTracking('Sponsor View', this.param);
    }

    goToUCL = () => {
        common.customTracking("Menu - Instant view - Access ucl logo", null, "navigation");
        const url = 'https://{LANG}.uefa.com/uefachampionsleague/';
        window.location.replace(url.replace('{LANG}', config.CURRENT_LANGUAGE));
    };
    goToHome = () => {
        // window.location.href = config.BASE_DOMAIN + config.CURRENT_LANGUAGE + '/' + config.APP_NAME;
        window.open('//' + window.location.host + '/' + config.CURRENT_LANGUAGE + '/' + config.APP_NAME, '_self');
    };
    adBannerClick = () => {
        common.adClickTracking('Sponsor Click', this.param);
        // window.open(config.PS4_URL, '_blank');
        // window.open(config.PS5_URL, '_blank');
        window.open(config.PS5Obj[config.CURRENT_LANGUAGE] ? config.PS5Obj[config.CURRENT_LANGUAGE] : "", '_blank');
    };

    render() {
        if (!this.state.isAdDetectcodeloaded) {
            return null;
        }
        const { trans, mobilePlayerListingOpen, totalScore } = this.props;
        const showScore = common.getGUID() && (totalScore !== null && totalScore != "");
        let className = '';
        if (mobilePlayerListingOpen) {
            className = ' si-display-none';
        }
        let isMobileView = window.innerWidth < 768;
        if (isMobileView) {
        } else {
            isMobileView = config.isMobile;
        }


        return <div className={ "si-ucl--head-wrap no-ad" + className }
            style={ { "height": this.state.adHeight } }
        >
            <div className="si-container">
                <div id="billboard" className="si-ad" style={ isMobileView ? { "display": "none" } : this.state.isAdBlocked ? { "display": "block", "margin": "0px" } : { "display": "block" } }>
                    <div id='div-gpt-ad-1410518459199-1' ref={ this.resizeElement }>
                        {/* <div id='div-gpt-ad-1410518459199-1'> */ }
                    </div>
                </div>
                <div className={ "si-ucl--head" } >
                    <div className="si-ucl--head-logo si-cursor-pointer" onClick={ () => this.goToUCL() } />
                    <div className="si-ucl--head-band">
                        <div className="si-ucl--head-bandContent">
                            <div className="si-ucl--head-bandTitle si-cursor-pointer" onClick={ () => this.goToHome() }>
                                <span>{ trans['Term_2'] || 'Fantasy Football' }</span>
                            </div>
                            <div className="si-ucl--head-bandMid">
                                <div className="si-ucl--head-bandViePts">
                                    { showScore ? <Fragment>
                                        <div className="si-ucl--head-bandViePts-title">
                                            <span>{ trans['totalTxt'] || "Total" }</span>
                                            <br></br>
                                            <span>{ trans['score'] || "Score" }</span>
                                        </div>
                                        <div className="si-ucl--head-bandViePts-nums">
                                            <span>{ totalScore }</span>
                                        </div>
                                        <div className="si-ucl--head-bandViePts-numsTxt">
                                            <span>{ trans['labelPts'] || "pts" }</span>
                                        </div>
                                    </Fragment> : null }

                                </div>
                                <div className="si-ucl--head-bandSprLogo si-cursor-pointer"
                                    onClick={ () => this.adBannerClick() }>
                                    <span>PRESENTED BY</span>
                                    <div className="si-top-sprLogo">
                                        <img src={ config.playerImgBase + "PSLogo.png?v=" + config.imgVersion } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="si-ucl--head-thirdPartyMenu">
                        <div className="si-ucl--head-thirdPartyMenu-fBox">
                            <div className="si-ucl--head-thirdPartyMenu-fItem">
                                <span>{ trans['gaming_hub'] }</span>
                            </div>
                            <div className="si-ucl--head-thirdPartyMenu-fItem">
                                { window.location.href.indexOf("index.html") > -1 ? "" :
                                    <GamingHubComponent /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="notify">
                <div className="ads">
                </div>
            </div>
        </div >
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        totalScore: state.appData.totalScore,
    };
};
export default (connect(mapStateToProps, null)(MainHeader));


// WEBPACK FOOTER //
// ./src/components/MainHeader.js